// this file is used for bootstraping only.
// avoid any js code except file imports.

// import packages
import 'promise-polyfill/src/polyfill';
import 'jquery.nicescroll';
import '@chenfengyuan/datepicker';
import '@chenfengyuan/datepicker/i18n/datepicker.de-DE';
import '@chenfengyuan/datepicker/i18n/datepicker.en-US';
import '@chenfengyuan/datepicker/i18n/datepicker.fr-FR';
import '@chenfengyuan/datepicker/i18n/datepicker.es-ES';
import '@chenfengyuan/datepicker/dist/datepicker.css';
import 'jquery-sticky';
import 'featherlight';
import 'featherlight/src/featherlight.css';
import 'slick-carousel';
import 'slick-carousel/slick/slick.css';
import 'leaflet/dist/leaflet.css';
// import styling
import './styles/main.scss';
// import scripts
import './scripts';



// WEBPACK FOOTER //
// ./src/index.js